var EHDI = EHDI || Object.create(null);

EHDI.game = EHDI.game || Object.create(null);

EHDI.game.Cloud = function () {
    EHDI.aka.Container.call(this);
}

EHDI.game.Cloud.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.game.Cloud.prototype.init = function (count) {
  this._cloudTexture;
  this._cloudSprite;
  this._cloudLightningTexture;
  this._cloudLightning;
  this._speed;

  this._lightningCount;
  this._lightningCountDelay;
  this._lightningCountAppearDelay;

  this._ligtningOn;

  if (this._cloudLightningTexture == null) {
    this._cloudLightningTexture = EHDI.Assets.images['lightning' + (count + 1)];
  }

  if (this._cloudTexture == null) {
    this._cloudTexture = EHDI.Assets.images['flood_cloud' + (count + 1)];
  }

  if (this._cloudLightning == null) {
    this._cloudLightning = EHDI.GetGlobalPool().spritePool.get();
    this._cloudLightning.texture = this._cloudLightningTexture;

    this._cloudLightning.x = -this._cloudLightning.width * 0.5;
    this._cloudLightning.y = this._cloudTexture.height * 0.9;
    this._cloudLightning.visible = false;

    this.addChild(this._cloudLightning);
  }

  if (this._cloudSprite == null) {
    this._cloudSprite = EHDI.GetGlobalPool().spritePool.get();
    this._cloudSprite.texture = this._cloudTexture;

    this._cloudSprite.x = -this._cloudSprite.width * 0.5;

    this.addChild(this._cloudSprite);
  }

  this._speed = Math.random() * 0.01 + 0.02;
  this._lightningCount = 0;
  this._lightningCountAppearDelay = 400;
  this.randomizeLighningCountDelay();
  this._ligtningOn = false;
};

EHDI.game.Cloud.prototype.randomizeLighningCountDelay = function() {
  this._lightningCountDelay = 1000 + Math.random() * 3000;
}

EHDI.game.Cloud.prototype.update = function (delta) {
  this.x -= this._speed * delta;
  this._lightningCount += delta;

  if (!this._ligtningOn) {
    if (this._lightningCount >= this._lightningCountDelay) {
      this._lightningCount = 0;
      this.randomizeLighningCountDelay();
      this._ligtningOn = true;
      this._cloudLightning.visible = true;
      this._cloudLightning.x =
      -75 + Math.random() * 150 - this._cloudLightning.width * 0.5;

      if (Math.random() >= 0.5)
        this._cloudLightning.scale.x = 1;
      else
        this._cloudLightning.scale.x = -1;
    }
  } else {
    if (this._lightningCount >= this._lightningCountAppearDelay) {
      this._lightningCount = 0;
      this._ligtningOn = false;
      this._cloudLightning.visible = false;
    }
  }

  if (this.x <= -500) {
    this.x = 1500 + this.x + 500;
  }
}

EHDI.game.Cloud.prototype.getSpeed = function () {
  return this._speed;
}
